//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'divline',
    props: {
        to: {
            default: 'javascript:history.back(-1);',
            type: String,
        },
        type: {
            default: 'line',
            type: String,
        }
    },
	data() {
		return {
            callback: '',
		}
    },
    methods: {

        initBrowserQuery(){

            // 进入页面时，带入的callback  回调页面，
            const cback = typeof this.$route.query.callback === 'string' ? this.$route.query.callback : this.to;
            this.callback = cback;

        }

    },
	mounted(){
        this.initBrowserQuery();
	}
}



// WEBPACK FOOTER //
// ./src/components/ui/navbar.vue